import React from 'react';
import { Helmet } from "react-helmet";
import Layout from '../components/Layout';
import { SecondaryButton } from '../audi-ui-components/Button';
import queryString from 'query-string';
import {
    UI_AUDI
} from '../constants';

const NotFound = ({ location }) => {
    const query = queryString.parse(location?.search) || {};
    return (
        <Layout ui={query.ui || UI_AUDI} embedded={query.embedded}>
            <div className="audi-forms__hero">
                <img src={`${process.env.PUBLIC_PATH}img/AUDI0120_AA4_A_191001_1160x386_R1.jpg`} alt="" style={{width: '100%'}} />
            </div>

            <main className="audi-forms__page not-found">
                <h1 className="aui-headline-3 mb-3 pt-5">Not found (404)</h1>
                <p className="aui-headline-5 mb-2">Sorry, page not found</p>
                <p className="mb-5">This page may have been removed, had its name changed or is temporarily unavailable.</p>
                <p className="mb-5">
                    <SecondaryButton label="Audi Australia" href="https://www.audi.com.au" />
                    {` `}
                    <SecondaryButton label="Explore models" href="https://www.audi.com.au/au/web/en/model-range.html" />
                </p>
            </main>
        </Layout>
    );
}

export default NotFound;
